const initialState = {
	savedAlbums: [],
	followedPlaylists: [],
	playlistTracks: [],
	categories: []
}

const spotifyApi = (state = initialState, action) => {
	switch (action.type) {
		case 'FETCH_SAVED_ALBUMS':
			return {
				...state,
				savedAlbums: action.payload
			}
		case 'FETCH_FOLLOWED_PLAYLISTS':
			return {
				...state,
				followedPlaylists: action.payload
			}
		case 'FETCH_PLAYLIST_TRACKS':
			return {
				...state,
				playlistTracks: [...state.playlistTracks, ...action.payload]
			}
		case 'FETCH_CATEGORIES':
			return {
				...state,
				categories: action.payload
			}
		case 'FETCH_CATEGORY_NAME':
			return {
				...state,
				categoryName: action.payload
			}
		case 'FETCH_CATEGORY_PLAYLISTS':
			return {
				...state,
				categoryPlaylists: action.payload
			}
		case 'CLEAR_PLAYLIST_TRACKS':
			return {
				...state,
				playlistTracks: []
			}
		default:
			return state
	}
}

export default spotifyApi



// WEBPACK FOOTER //
// ./src/reducers/spotifyApi.js